import { Loading } from '@livecontrol/core-ui';
import { Scheduler } from '@livecontrol/scheduler/store';
import type { ReactElement } from 'react';
import { Store } from '../../../store';
import { BillingContact } from './billing-contact';
import { Header } from './header';
import { Information } from './information';
import { Invoices } from './invoices';
import { PaymentMethod } from './payment-method';
import { Subscription } from './subscription';

export const Billing = (): ReactElement => {
  const account = Store.Account.useAccount();
  const me = Store.User.useMe();

  const { billingInfo, loading: loadingBillingInfo } = Scheduler.Billing.useSubscriptionAccountInfo(account.id);

  const { billing, loading } = Scheduler.Account.useBilling(account);

  return (
    <div className='d-flex flex-column'>
      {
        loading || loadingBillingInfo ? <Loading.Delay /> : (
          <>
            <Header />
            <Information renewalDate={me.userAccountDetails?.renewalDate} plan={billingInfo?.plan} account={account} billing={billing}/>
            <Subscription nextBillingDate={billingInfo?.subscription?.nextBillingDate} stripeURL={billing?.stripe.url} />
            <PaymentMethod expMonth={billing?.stripe.expMonth} stripeURL={billing?.stripe.url} />
            <BillingContact billingContact={billingInfo?.billingContact} />
            {billingInfo?.invoices && <Invoices account={account} invoices={billingInfo.invoices} />}
          </>
        )
      }
    </div>
  );
};
